import { addMinutes, format } from 'date-fns'
import formatDuration from 'app/functions/formatDuration'
import StartedFinished from 'app/dodones/shared/StartedFinished'

function roundDownToNearestStep(date, stepMinutes) {
  const minutes = date.getMinutes()
  const roundedMinutes = Math.floor(minutes / stepMinutes) * stepMinutes

  const result = new Date(date)
  result.setMinutes(roundedMinutes, 0, 0)
  return result
}

function timelineDates(startDate, endDate, stepMinutes) {
  // Round down the start date
  const start = roundDownToNearestStep(startDate, stepMinutes)

  // Round up the end date
  const end = new Date(endDate)
  const minutes = end.getMinutes()
  const roundedMinutes = Math.ceil(minutes / stepMinutes) * stepMinutes
  end.setMinutes(roundedMinutes, 0, 0)

  // Generate the list
  const dates = []
  const current = new Date(start)

  while (current <= end) {
    dates.push(new Date(current))
    current.setMinutes(current.getMinutes() + stepMinutes)
  }

  return dates
}

const DodoneTimelineItem = ({ startedAt, pixelsPerMinute, dodone }) => {
  const diffInMillisecondsFromTimelineStart =
    dodone.startedAt.getTime() - startedAt.getTime()

  const diffInMinutesFromTimelineStart =
    diffInMillisecondsFromTimelineStart / (1000 * 60)

  const top = diffInMinutesFromTimelineStart * pixelsPerMinute + 10
  const height = (dodone.duration * pixelsPerMinute) / 60
  const isSmall = height < 20

  const topPx = `${top}px`
  const bottomPx = `${top + height}px`

  return (
    <>
      <div
        className={clsx('timeline-item', { 'timeline-item-sm': isSmall })}
        style={{ top: topPx, height: isSmall ? 'auto' : `${height}px` }}
      >
        <div className="timeline-item-header">
          <div className="flex-1">{dodone.listItemText}</div>
          <StartedFinished includePreviousDate={false} dodone={dodone} />
        </div>
        <div className="timeline-item-extra">
          {dodone.comment && <div className="text-xs">{dodone.comment}</div>}
        </div>
      </div>
    </>
  )
}

export default ({ dodone }) => {
  const completeDodones = useMemo(() => {
    return dodone.children.filter((child) => {
      return child.isCompleted
    })
  }, [dodone])

  if (completeDodones.length == 0) return <div>Faça algo antes né parça</div>

  const startedAt = dodone.startedAt
  const finishedAt = dodone.isCompleted
    ? dodone.finishedAt
    : completeDodones[completeDodones.length - 1].finishedAt

  const minutesStep = 20
  const timelineTimeItemHeight = 60
  const pixelsPerMinute = timelineTimeItemHeight / minutesStep

  const dates = useMemo(() => {
    return timelineDates(startedAt, finishedAt, minutesStep)
  }, [startedAt, finishedAt])

  const fakeDodones = useMemo(() => {
    return Object.entries(dates).map(([index, date]) => {
      return {
        id: index,
        startedAt: date,
        finishedAt: addMinutes(date, 10),
        dodoable: {
          name: index
        },
        duration: 10 * 60
      }
    })
  })

  return (
    <div
      className="fcol flex-1 timeline-wrapper"
      style={{ overflowY: 'scroll' }}
    >
      <div className="flex-1 timeline">
        <div className="timeline-times">
          {dates.map((date) => {
            const formattedDate = format(date, 'HH:mm')
            return (
              <div
                className="timeline-time"
                key={formattedDate}
                style={{ height: `${timelineTimeItemHeight}px` }}
              >
                {formattedDate}
              </div>
            )
          })}
        </div>
        <div className="timeline-items">
          {completeDodones.map((dodone) => {
            return (
              <DodoneTimelineItem
                dodone={dodone}
                key={dodone.id}
                pixelsPerMinute={pixelsPerMinute}
                startedAt={startedAt}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
